import styled from 'styled-components';
import { ParticipatedAssignmentListItemComponent } from './participated-assignment-list-item.component';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var CardList = styled.div.withConfig({
  displayName: "participated-assignment-listcomponent__CardList",
  componentId: "sc-9tz4lv-0"
})(["display:flex;flex-direction:column;gap:", ";width:100%;"], getSize('padding8'));
export var ParticipatedAssignmentListComponent = function ParticipatedAssignmentListComponent(_ref) {
  var dataSources = _ref.dataSources,
      columnLabels = _ref.columnLabels,
      navigateToSubmissionDetail = _ref.navigateToSubmissionDetail;
  return /*#__PURE__*/_jsx(CardList, {
    children: dataSources.map(function (record) {
      return /*#__PURE__*/_jsx(ParticipatedAssignmentListItemComponent, {
        record: record,
        columnLabels: columnLabels,
        navigateToSubmissionDetail: navigateToSubmissionDetail
      }, record.id.toValue());
    })
  });
};